<template>
  <component-wrapper class="media-library-page-fi">
    <grid-container-fi class="media-library-page-fi__grid-container">
      <div class="media-library-page-fi__headlines">
        <headline-fi
          v-if="fields.subheadline?.value"
          class="media-library-page-fi__subheadline"
          tag="h2"
          :size="30"
        >
          {{ fields.subheadline.value }}
        </headline-fi>
        <headline-fi
          v-if="fields.headline?.value"
          class="media-library-page-fi__headline"
          tag="h1"
          :size="60"
        >
          {{ fields.headline.value }}
        </headline-fi>
      </div>

      <div class="media-library-page-fi__library-container">
        <media-library-fi />
      </div>
    </grid-container-fi>
  </component-wrapper>
</template>

<script setup lang="ts">
import { HeadlineFi } from 'atoms';

import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';
import MediaLibraryFi from '@/components/media-library-fi/MediaLibraryFi.vue';
import { useFields } from '@/composables/fields';

defineOptions({ name: 'MediaLibraryPageFi' });

const fields = useFields('MediaLibraryPageFiFields');
</script>

<style scoped src="./media-library-page-fi" />
